
import { mapState } from "vuex"
import layoutMixin from "@/mixins/layout"

export default layoutMixin.extend({
  computed: {
    ...mapState("app", ["stage3"]),
  },
})
